<template>
  <div class="login">

    <!-- Comment old code -->
    <!-- <div class="login-header">
      <img class="background-img" src="@/assets/rectangle.png" alt />
      <div class="app-name">
        <a href>
          <span style="font-weight:bolder">Pay</span>lief
        </a>
        <div class="by-teamlease">By TeamLease</div>
      </div>
      <div class="page-content">
        <div class="description">
          <div>Welcome to Paylief</div>
          <p>India's most trusted Payroll Solution is here. Leave all your payroll related tasks to us which will help you focus on your core business.</p>
        </div>
        <div class="signinform">
          <slot></slot>
        </div>
      </div>
    </div> -->
    <!-- End here old code -->

    <!-- New code added here for login page UI -->
    <div class="row">
      <div class="col-8 pl-0">
        <div class="login-header">
          <!-- <img class="background-img" src="@/assets/rectangle.png" alt /> -->
          <div class="app-name">
            <a href>
              <span style="font-weight:bolder">Pay</span>lief
            </a>
            <div class="by-teamlease">By TeamLease</div>
          </div>
          <div class="page-content">
            <div class="description">
              <div>Welcome to Paylief</div>
              <p>India's most trusted Payroll Solution is here. Leave all your payroll related tasks to us which will help you focus on your core business.</p>
              <img src="@/assets/Mar-Business_1.svg" alt />            
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="signinform">
          <slot></slot>
        </div>
      </div>
    </div>
    <!-- End here code -->
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.login-header {
  // background-image: url("../assets/rectangle.png") no-repeat center;
  padding: 44px 140px 50px 62px;
  // background-size: 100%;
  width: 100%;
  //height: 400px;  old css comment 
  position: relative;
  min-height: 100vh;  // new css apply
  background: #34c0be;
}
.login-header .background-img {
  position: absolute;
  top: 0;
  left: 0;
  height: 500px;
  width: 100%;
  z-index: -1;
}
.app-name a {
  width: 72px;
  height: 24px;
  font-size: 26px;
  color: #ffffff;
  font-family: Montserrat;
  border-bottom: 2px inset #fdfdfdab;
  text-decoration: none;
}
.app-name .by-teamlease {
  height: 15px;
  padding-top: 2px;
  font-family: Montserrat;
  font-size: 12.4px;
  color: #ffffff;
}
.login-tab {
  position: relative;
  width: 100%;
}
.router-link-exact-active {
  border-bottom: 4px solid #fff;
  font-weight: bold;
}
hr {
  margin-top: 4px;
  border: none;
  background-color: #fff;
  color: #fff;
  height: 1px;
}
.page-content {
  margin-top: 34px;
  width: 100%;
  //display: flex;
  text-align: center;
}
.page-content .description {
  //width: 50%;
  margin-top: 60px;
}
.page-content .signinform {
  width: 36%;
  margin-left: auto;
}
.description div {
  //width: 287px;
  //height: 34px;
  font-family: Montserrat;
  font-size: 28px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
}
.description p {
  margin-top: 12px;
  //width: 294px;
  height: 123px;
  font-family: Montserrat;
  font-size: 16px;
  color: #ffffff;
  padding: 1px 100px;
  line-height: 1.9rem;
  text-align: center;
}
.view-demo button {
  outline: 0;
  width: 144px;
  cursor: pointer;
  height: 45px;
  font-weight: 500;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: none;
  background-color: #ffffff;
  color: #5d409f;
  font-size: 15px;
}
@media only screen and (max-width: 600px) {
  .login-tab {
    position: none;
    width: 100%;
  }
  .page-content {
    flex-direction: column-reverse;
  }
  .page-content .form {
    width: 100%;
    margin-top: 30px;
  }
  .login-header {
    padding: 10px 40px 0px 42px;
  }
  .page-content .description {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .page-content .form {
    width: 50%;
  }
  .login-header {
    padding: 44px 50px 50px 50px;
  }
}


//Css is apply for signup form By Bhushan
.login {
  position: absolute;
  //height: 800px;
}

.signinform {
  position: relative;
  top: 31%;
  left: 1%;
  margin: -25px 0 0 -25px;
}

</style>
